// extracted by mini-css-extract-plugin
export default {"mainPowerTooltip":"LayoutHeader_mainPowerTooltip__bF-Nn","subRightButton":"LayoutHeader_subRightButton__lzz44"};